import ENV from "../lib/config";

export const getApiUrl = (path) => `${ENV.get().REACT_APP_AUTH_API_URL}${path}`;
